if (!customElements.get('cs-cart-upsells')) {
  customElements.define('cs-cart-upsells', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-cu-scroll]');
        if (!button) return;
        const track = button.closest('[data-cu-row]').querySelector('.cs-cu__track');
        track.scrollBy({left: Number(button.dataset.cuScroll) * track.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      });
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-cu-variant]')) return;
        const option = event.target.selectedOptions[0];
        if (!option?.value) return;
        const card = event.target.closest('.cs-cu__card');
        card.querySelector('[data-cu-price]').textContent = option.dataset.price;
        const compare = card.querySelector('[data-cu-compare]');
        compare.textContent = option.dataset.compare;
        compare.hidden = !option.dataset.compare;
        card.querySelector('[data-cu-error]').hidden = true;
      });
      this.addEventListener('submit', event => {
        if (!event.target.matches('[data-cu-form]')) return;
        event.preventDefault();
        this.addItem(event.target);
      });
      this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
      this.querySelectorAll('.cs-cu__track').forEach(track => {
        track.addEventListener('scroll', () => this.updateNavigation(), {passive: true});
        this.resizeObserver.observe(track);
      });
      this.updateNavigation();
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }
    updateNavigation() {
      this.querySelectorAll('[data-cu-row]').forEach(row => {
        const track = row.querySelector('.cs-cu__track');
        row.querySelector('[data-cu-scroll="-1"]').disabled = track.scrollLeft < 2;
        row.querySelector('[data-cu-scroll="1"]').disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      });
    }
    async addItem(form) {
      if (this.busy || !form.reportValidity()) return;
      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      const button = form.querySelector('[type=submit]');
      const error = form.querySelector('[data-cu-error]');
      const variantId = new FormData(form).get('id');
      const rowNumber = form.closest('[data-cu-row]').dataset.cuRow;
      button.disabled = true;
      button.textContent = button.dataset.loading;
      error.hidden = true;
      const root = this.dataset.root.replace(/\/?$/, '/');
      const cartUrl = this.dataset.cartUrl;
      let added = false;
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items: [{id: Number(variantId), quantity: 1}], sections: ['cart-drawer', 'cart-bubble'], sections_url: window.location.pathname})
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : error.dataset.fallback);
        added = true;
        const parser = new DOMParser();
        const incoming = parser.parseFromString(result.sections?.['cart-drawer'] || '', 'text/html').querySelector('#Cart-Drawer');
        const drawer = document.getElementById('Cart-Drawer');
        if (!incoming || !drawer) {
          window.location.assign(cartUrl);
          return;
        }
        const scrollTop = drawer.querySelector('.side-panel-content')?.scrollTop || 0;
        const rowScroll = Array.from(this.querySelectorAll('[data-cu-row]'), row => [row.dataset.cuRow, row.querySelector('.cs-cu__track').scrollLeft]);
        drawer.innerHTML = incoming.innerHTML;
        const bubble = parser.parseFromString(result.sections?.['cart-bubble'] || '', 'text/html').querySelector('.thb-item-count');
        const currentBubble = document.querySelector('#cart-drawer-toggle .thb-item-count');
        if (bubble && currentBubble) currentBubble.innerHTML = bubble.innerHTML;
        if (typeof CartDrawer !== 'undefined' && CartDrawer.instance) {
          CartDrawer.instance.removeProductEvent();
          CartDrawer.instance.notesToggle();
          CartDrawer.instance.termsCheckbox();
        }
        document.body.classList.add('open-cc');
        drawer.classList.add('active');
        const content = drawer.querySelector('.side-panel-content');
        if (content) content.scrollTop = scrollTop;
        rowScroll.forEach(([row, left]) => {
          const track = drawer.querySelector(`[data-cu-row="${row}"] .cs-cu__track`);
          if (track) track.scrollLeft = left;
        });
        const focusTarget = drawer.querySelector(`[data-cu-row="${rowNumber}"] .cs-cu__button`) || drawer.querySelector('.checkout');
        focusTarget?.focus({preventScroll: true});
        const status = drawer.querySelector('[data-cu-status]');
        if (status) status.textContent = status.dataset.added;
        document.dispatchEvent(new CustomEvent('cart:item-added', {bubbles: true, detail: {product: result.items?.[0], items: result.items}}));
        if (document.getElementById('Cart')) document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (failure) {
        if (added) window.location.assign(cartUrl);
        else {
          error.textContent = failure.message || error.dataset.fallback;
          error.hidden = false;
        }
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
        button.disabled = false;
        button.textContent = button.dataset.idle;
      }
    }
  });
}
